// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-summary-card-dropdown{max-height:0;overflow:hidden;transition:max-height .15s ease-out}.product-summary-card-dropdown--open{max-height:800px;transition:max-height .25s ease-in}@media print{.product-summary-card-dropdown{max-height:800px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
